// extracted by mini-css-extract-plugin
export default {"container":"Vendors_container__GH3dt","body":"Vendors_body__-ccLo"};